import { GET_DETAIL_STUDY_SUCCESS } from "../actions/patientAction"

const getStudyDetailReducer = (state = [], { type,  data = [] }) => {
    switch (type) {
      case GET_DETAIL_STUDY_SUCCESS:
        return data
      default:
        return state
    }
  }
  
  export default getStudyDetailReducer